var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons-shipping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M8.95,17.001C8.983,17.162 9,17.329 9,17.5C9,18.881 7.881,20 6.5,20C5.119,20 4,18.881 4,17.5C4,17.329 4.017,17.162 4.05,17.001L2,17L2,4L15,4L15,6L20,6L22,12.091L22,17L19.95,17.001C19.983,17.162 20,17.329 20,17.5C20,18.881 18.881,20 17.5,20C16.119,20 15,18.881 15,17.5C15,17.329 15.017,17.162 15.05,17.001L8.95,17.001ZM17.5,17C17.224,17 17,17.224 17,17.5C17,17.776 17.224,18 17.5,18C17.776,18 18,17.776 18,17.5C18,17.224 17.776,17 17.5,17ZM6.5,17C6.224,17 6,17.224 6,17.5C6,17.776 6.224,18 6.5,18C6.776,18 7,17.776 7,17.5C7,17.224 6.776,17 6.5,17ZM13,6L4,6L4,15L13,15L13,6ZM18.577,8L15,8L15,12.063L20,12.063L18.577,8Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.0194c689.svg";
export { ForwardRef as ReactComponent };